export enum SignInType {
    FACEBOOK = 'facebook',
    LINE = 'line',
    NAVER = 'naver',
    KAKAO = 'kakao',
    GOOGLE = 'google',
    TWITTER = 'twitter',
    APPLE = 'apple',
    RAKUTEN = 'rakuten',
    GUEST = 'guest'
}

// TODO: APACRIGEL-1415 Define a type with all social providers, since there might be more sign-in types added
export type SignInTypeWithoutGuest = Exclude<SignInType, SignInType.GUEST>;

export const isSocialSignIn = (
    signInType?: SignInType
): signInType is Exclude<SignInType, SignInType.GUEST> =>
    ![undefined, SignInType.GUEST].includes(signInType);
